module.exports = __webpack_public_path__ + "img/radar_yellow.18c2ae80.svg";